export default __webpack_public_path__ + "static/media/high-shield.b83d7fa9.png";